import {
	NAVIGABLE_SECTION_IDS,
	useScrollToNavigableSection,
} from '@/components/content/ProductDetails/hooks/useScrollToNavigableSection';
import { useSettings } from '@/data/Settings';
import { useEffect, useState } from 'react';

type BVEvent = 'show';

type BVType = {
	swat_questions: {
		on: (event: BVEvent, func: () => void) => void;
		off: (event: BVEvent, func: () => void) => void;
	};
	swat_reviews: {
		on: (event: BVEvent, func: () => void) => void;
		off: (event: BVEvent, func: () => void) => void;
	};
	configure: (
		scope: 'global' | string,
		options: {
			events?: {
				bvRender?: (data: unknown) => void;
			};
		}
	) => void;
};

declare global {
	interface Window {
		bvCallback: undefined | ((BV: BVType) => void);
		BV?: BVType;
	}
}

export const useBazaarVoice = () => {
	const { settings } = useSettings();
	const { scrollToNavigableSection } = useScrollToNavigableSection();
	const [isBVWidgetRender, setIsBVWidgetRender] = useState(false);

	useEffect(() => {
		let questionsHandler: (() => void) | undefined;
		let reviewsHandler: (() => void) | undefined;

		try {
			window.bvCallback = (BV) => {
				try {
					questionsHandler = () => {
						try {
							scrollToNavigableSection({
								sectionId: NAVIGABLE_SECTION_IDS.PRODUCT_QUESTIONS,
							});
						} catch (err) {
							console.error('[BV] Error handling questions show', err);
						}
					};

					reviewsHandler = () => {
						try {
							scrollToNavigableSection({
								sectionId: NAVIGABLE_SECTION_IDS.PRODUCT_REVIEWS,
							});
						} catch (err) {
							console.error('[BV] Error handling reviews show', err);
						}
					};

					BV.swat_questions.on('show', questionsHandler);
					BV.swat_reviews.on('show', reviewsHandler);

					BV.configure('global', {
						events: {
							bvRender: () => {
								setIsBVWidgetRender(true);
							},
						},
					});
				} catch (err) {
					console.error('[BV] Error registering show handlers', err);
				}
			};
		} catch (err) {
			console.error('[BV] Error setting bvCallback', err);
		}

		if (document.getElementById('bv-script') === null) {
			const script = document.createElement('script');
			script.src = `https:${settings?.userData?.BAZAARVOICE_URL}`;
			script.id = 'bv-script';
			script.async = true;
			document.body.appendChild(script);
		}

		return () => {
			try {
				if (window.BV) {
					if (questionsHandler) {
						window.BV.swat_questions.off('show', questionsHandler);
					}
					if (reviewsHandler) {
						window.BV.swat_reviews.off('show', reviewsHandler);
					}
				}
			} catch (err) {
				console.error('[BV] Error cleaning up handlers', err);
			}

			window.bvCallback = undefined;
		};
	}, [scrollToNavigableSection, settings?.userData?.BAZAARVOICE_URL]);

	return isBVWidgetRender;
};
